// Proyectos que combinan varias piezas.
import { at, part, wires, UNO } from './helpers.js';

const BB = { id: 'bb1', type: 'breadboard', x: 0, z: -80, rot: 0, props: { size: 'half' } };

function piano() {
  const parts = [UNO, BB];
  const list = [];
  const cols = [4, 10, 16, 22];
  const colors = ['red', 'yellow', 'green', 'blue'];
  const keys = ['a', 's', 'd', 'f'];
  const rail = [5, 10, 15, 20];
  cols.forEach((c, i) => {
    parts.push(part('btn' + (i + 1), 'pushbutton', { color: colors[i], key: keys[i] }, at(BB, 'e' + c, 'pushbutton')));
    list.push(['uno:' + (2 + i), 'bb1:a' + c, colors[i]]);
    list.push(['bb1:j' + (c + 2), 'bb1:bn' + rail[i], 'black']);
  });
  parts.push(part('buzzer1', 'buzzer', { mode: 'passive' }, at(BB, 'f26', 'buzzer')));
  list.push(['uno:8', 'bb1:j29', 'orange'], ['bb1:j26', 'bb1:bn21', 'black'], ['bb1:bn1', 'uno:GND.1', 'black']);
  return { parts, wires: wires(list) };
}

export const EXAMPLES = [
  {
    id: 'piano',
    category: 'Proyectos',
    name: 'Piano de 4 botones',
    description: 'Cada botón toca una nota en el zumbador. También puedes tocar con las teclas A, S, D y F de tu teclado.',
    project: {
      name: 'Piano',
      files: {
        'sketch.ino': `// Piano de 4 notas: cada botón (o las teclas A, S, D, F) toca una nota en el zumbador.

const int BOTONES[4] = { 2, 3, 4, 5 };
const int NOTAS[4] = { 262, 330, 392, 523 };   // Do, Mi, Sol y Do agudo
const char *NOMBRES[4] = { "Do", "Mi", "Sol", "Do agudo" };
const int ZUMBADOR = 8;

void setup() {
  Serial.begin(9600);
  for (int i = 0; i < 4; i++) pinMode(BOTONES[i], INPUT_PULLUP);
}

void loop() {
  for (int i = 0; i < 4; i++) {
    if (digitalRead(BOTONES[i]) == LOW) {
      tone(ZUMBADOR, NOTAS[i]);
      Serial.println(NOMBRES[i]);
      while (digitalRead(BOTONES[i]) == LOW) delay(5);
      noTone(ZUMBADOR);
    }
  }
}
`,
      },
      ...piano(),
    },
  },
  {
    id: 'reflejos',
    category: 'Proyectos',
    name: 'Juego de reflejos',
    description: 'Cuando se enciende el LED, presiona el botón lo más rápido que puedas. La LCD muestra tu tiempo y tu mejor marca.',
    project: {
      name: 'Juego de reflejos',
      files: {
        'sketch.ino': `// Juego de reflejos: espera a que se encienda el LED y presiona el botón (o la tecla espacio).
#include <Wire.h>
#include <LiquidCrystal_I2C.h>

LiquidCrystal_I2C lcd(0x27, 16, 2);
const int BOTON = 2;
const int LED = 13;
unsigned long mejor = 0;

void setup() {
  pinMode(BOTON, INPUT_PULLUP);
  pinMode(LED, OUTPUT);
  lcd.init();
  lcd.backlight();
  randomSeed(micros());
}

void loop() {
  lcd.clear();
  lcd.print("Preparate...");
  unsigned long espera = millis() + random(1500, 4000);
  while (millis() < espera) {
    if (digitalRead(BOTON) == LOW) {       // presionó antes de tiempo
      lcd.clear();
      lcd.print("Muy pronto!");
      delay(1500);
      return;
    }
  }
  digitalWrite(LED, HIGH);
  unsigned long inicio = millis();
  while (digitalRead(BOTON) == HIGH) {}
  unsigned long tiempo = millis() - inicio;
  digitalWrite(LED, LOW);
  if (mejor == 0 || tiempo < mejor) mejor = tiempo;

  lcd.clear();
  lcd.print("Tiempo: ");
  lcd.print(tiempo);
  lcd.print(" ms");
  lcd.setCursor(0, 1);
  lcd.print("Mejor:  ");
  lcd.print(mejor);
  lcd.print(" ms");
  while (digitalRead(BOTON) == LOW) {}
  delay(2500);
}
`,
      },
      parts: [
        UNO,
        BB,
        part('btn1', 'pushbutton', { color: 'red', key: ' ' }, at(BB, 'e10', 'pushbutton')),
        part('led1', 'led', { color: 'green' }, at(BB, 'f20', 'led')),
        part('r1', 'resistor', { value: 220 }, at(BB, 'h21', 'resistor')),
        part('lcd1', 'lcd-i2c', { size: '16x2', color: 'blue' }, { x: 12, z: 78, rot: 0 }),
      ],
      wires: wires([
        ['uno:2', 'bb1:a10', 'yellow'],
        ['bb1:j12', 'bb1:bn10', 'black'],
        ['uno:13', 'bb1:j25', 'green'],
        ['bb1:j20', 'bb1:bn16', 'black'],
        ['bb1:bn6', 'uno:GND.1', 'black'],
        ['uno:GND.2', 'lcd1:GND', 'black'],
        ['uno:5V', 'lcd1:VCC', 'red'],
        ['uno:A4', 'lcd1:SDA', 'blue'],
        ['uno:A5', 'lcd1:SCL', 'yellow'],
      ]),
    },
  },
  {
    id: 'cerradura-rfid',
    category: 'Proyectos',
    name: 'Cerradura con RFID y servo',
    description: 'La tarjeta autorizada gira el servo para abrir durante 3 segundos; con otra tarjeta, el LED parpadea en señal de rechazo.',
    project: {
      name: 'Cerradura RFID',
      files: {
        'sketch.ino': `// Cerradura: el servo abre con la tarjeta autorizada (clic en la tarjeta para acercarla).
#include <SPI.h>
#include <MFRC522.h>
#include <Servo.h>

MFRC522 rfid(10, 9);
Servo cerrojo;
const byte AUTORIZADA[4] = { 0x9A, 0x3B, 0x5C, 0x1D };

void setup() {
  Serial.begin(9600);
  SPI.begin();
  rfid.PCD_Init();
  cerrojo.attach(6);
  cerrojo.write(0);            // cerrado
  pinMode(LED_BUILTIN, OUTPUT);
  Serial.println("Cerradura lista");
}

void loop() {
  if (!rfid.PICC_IsNewCardPresent() || !rfid.PICC_ReadCardSerial()) return;
  bool ok = rfid.uid.size == 4 && memcmp(rfid.uid.uidByte, AUTORIZADA, 4) == 0;
  rfid.PICC_HaltA();
  if (ok) {
    Serial.println("Bienvenido: abriendo");
    cerrojo.write(90);
    delay(3000);
    cerrojo.write(0);
    Serial.println("Cerrado");
  } else {
    Serial.println("Tarjeta no autorizada");
    for (int i = 0; i < 6; i++) {
      digitalWrite(LED_BUILTIN, !digitalRead(LED_BUILTIN));
      delay(150);
    }
  }
}
`,
      },
      parts: [
        UNO,
        part('rfid1', 'rfid-rc522', {}, { x: -6, z: -96, rot: 0 }),
        part('servo1', 'servo', { horn: 'single' }, { x: 100, z: -4, rot: 0 }),
      ],
      wires: wires([
        ['rfid1:SDA', 'uno:10', 'yellow'],
        ['rfid1:SCK', 'uno:13', 'orange'],
        ['rfid1:MOSI', 'uno:11', 'blue'],
        ['rfid1:MISO', 'uno:12', 'purple'],
        ['rfid1:RST', 'uno:9', 'white'],
        ['rfid1:GND', 'uno:GND.1', 'black'],
        ['rfid1:3.3V', 'uno:3.3V', 'red'],
        ['servo1:PWM', 'uno:6', 'orange'],
        ['servo1:V+', 'uno:5V', 'red'],
        ['servo1:GND', 'uno:GND.2', 'black'],
      ]),
    },
  },
  {
    id: 'estacion',
    category: 'Proyectos',
    name: 'Estación meteorológica',
    description: 'Un BMP280 mide temperatura y presión, calcula la altitud y lo muestra en una LCD I²C (dos dispositivos en el mismo bus).',
    project: {
      name: 'Estación meteorológica',
      files: {
        'sketch.ino': `// Estación meteorológica: BMP280 (0x76) y LCD 16x2 (0x27) en el mismo bus I2C.
// Cambia la temperatura o la presión del sensor en el panel de propiedades.
#include <Wire.h>
#include <Adafruit_BMP280.h>
#include <LiquidCrystal_I2C.h>

Adafruit_BMP280 bmp;
LiquidCrystal_I2C lcd(0x27, 16, 2);

void setup() {
  Serial.begin(9600);
  lcd.init();
  lcd.backlight();
  if (!bmp.begin(0x76)) {
    lcd.print("Sin BMP280");
    while (true) {}
  }
}

void loop() {
  float t = bmp.readTemperature();
  float p = bmp.readPressure() / 100.0;     // hPa
  float h = bmp.readAltitude(1013.25);       // m sobre el nivel del mar
  lcd.setCursor(0, 0);
  lcd.print(t, 1);
  lcd.print((char)223);                      // símbolo de grados de la LCD
  lcd.print("C ");
  lcd.print(h, 0);
  lcd.print(" m    ");
  lcd.setCursor(0, 1);
  lcd.print(p, 1);
  lcd.print(" hPa    ");
  Serial.print(t);
  Serial.print(",");
  Serial.println(p);
  delay(500);
}
`,
      },
      parts: [
        UNO,
        part('bmp1', 'bmp280', { temperature: 21.5, pressure: 780.2 }, { x: -24, z: -46, rot: 0 }),
        part('lcd1', 'lcd-i2c', { size: '16x2', color: 'green' }, { x: 12, z: 78, rot: 0 }),
      ],
      wires: wires([
        ['bmp1:VCC', 'uno:3.3V', 'red'],
        ['bmp1:GND', 'uno:GND.1', 'black'],
        ['bmp1:SCL', 'uno:SCL', 'yellow'],
        ['bmp1:SDA', 'uno:SDA', 'blue'],
        ['uno:GND.2', 'lcd1:GND', 'black'],
        ['uno:5V', 'lcd1:VCC', 'red'],
        ['uno:A4', 'lcd1:SDA', 'blue'],
        ['uno:A5', 'lcd1:SCL', 'yellow'],
      ]),
    },
  },
];
